import sysEnv from '@/env/envs'

import {
  pointChange
} from '@/cllib/mapTools'

export const convertLine = (array, obj) => {
  let flag = true
  array.forEach((e) => {
    if (e.name === obj.name) {
      flag = false
      e.coords.push(pointChange([obj.lng, obj.lat]))
    }
  })
  if (flag) {
    array.push({
      name: obj.name,
      coords: [pointChange([obj.lng, obj.lat])]
    })
  }
  return array
}

let sealSizeNum = {
  '0': 4000,
  '92': 3000,
  '95': 1500,
  '98': 500,
  'total': 10000
}

export const shiZb = [{
  'area': '西双版纳傣族自治州',
  'cnpc': '0.5571',
  'snpc': '0.4429'
},
{
  'area': '楚雄彝族自治州',
  'cnpc': '0.5172',
  'snpc': '0.4828'
},
{
  'area': '丽江市',
  'cnpc': '0.4926',
  'snpc': '0.5074'
},
{
  'area': '保山市',
  'cnpc': '0.4878',
  'snpc': '0.5122'
},
{
  'area': '昭通市',
  'cnpc': '0.4387',
  'snpc': '0.5613'
},
{
  'area': '普洱市',
  'cnpc': '0.4251',
  'snpc': '0.5749'
},
{
  'area': '德宏傣族景颇族自治州',
  'cnpc': '0.4059',
  'snpc': '0.5941'
},
{
  'area': '迪庆藏族自治州',
  'cnpc': '0.3647',
  'snpc': '0.6353'
},
{
  'area': '文山壮族苗族自治州',
  'cnpc': '0.3429',
  'snpc': '0.6571'
},
{
  'area': '玉溪市',
  'cnpc': '0.3349',
  'snpc': '0.6651'
},
{
  'area': '昆明市',
  'cnpc': '0.3123',
  'snpc': '0.6877'
},
{
  'area': '红河哈尼族彝族自治州',
  'cnpc': '0.3096',
  'snpc': '0.6904'
},
{
  'area': '大理白族自治州',
  'cnpc': '0.3071',
  'snpc': '0.6929'
},
{
  'area': '临沧市',
  'cnpc': '0.2982',
  'snpc': '0.7018'
},
{
  'area': '曲靖市',
  'cnpc': '0.2473',
  'snpc': '0.7527'
}]

let getSaleType = (sale) => {
  let saleType = null
  if (!sale || sale < 3000) {
    saleType = 'xy3'
  } else if (sale < 5000) {
    saleType = 'qj3z5'
  } else if (sale < 10000) {
    saleType = 'qj5z10'
  } else {
    saleType = 'dy10'
  }
  return saleType
}

let maxSize = 35
let minSize = 20

let getSizeFunSeal = (data, num) => {
  num = num || 1000
  let sale = Number(data) || 0
  let size = ((sale / num) > 1 ? 1 : (sale / num)) * maxSize
  return size > minSize ? size : minSize
}

export const tooltipF1 = function (data) {
  if (['pipe', 'pipe_bak', 'pipe2', 'pipe2_bak'].includes(data.seriesId)) {
    return '管道: ' + data.data.name
  } else if (data.seriesId.includes('gas_zsy_warning')) {
    let reStr = (data.name || '')
    if (data.isWarning) {
      reStr += '<br>' + data.isWarning
      return reStr
    }
  } else if (data.seriesId === 'railway') {
    return '铁路: ' + data.data.name
  } else if (data.seriesId.includes('depot')) {
    data = data.data.data
    let reStr = ''
    reStr += data.name + '<br/>油品: '
    if (data.o0 === 1) {
      reStr += '0# '
    }
    if (data.o92 === 1) {
      reStr += '92# '
    }
    if (data.o95 === 1) {
      reStr += '95# '
    }
    if (data.o98 === 1) {
      reStr += '98# '
    }
    return reStr
  } else {
    data = data.data.data
    let reStr = ''
    if (data && data.length && data.length > 0) {
      reStr = '加油站数量:  ' + data.length + '<br>'
      if (data.length < 5) {
        data.forEach((item, index) => {
          reStr += item.name + '<br>'
        })
      }
      return reStr
    }
    reStr += (data.name || '')
    if (data.isWarning) {
      reStr += '<br>' + data.isWarning
      return reStr
    }
    for (let key in data) {
      if (['0', '92', '95', '98', '柴油', '汽油'].includes(key)) {
        reStr += data[key].oil ? ('<br>' + ((data[key].oil) === '0' ? ' &nbsp 0' : data[key].oil) + '#') : ''
        reStr += data[key].sale ? ((' 8月日均销量: ' + data[key].day8sale) + '吨') : ''
        reStr += data[key].process ? ((' 8月日均销量同比: ' + ((Number(data[key].huanbi8) || 0) * 100).toFixed(0)) + '%') : ''
        reStr += data[key].oil ? ('<br>' + ((data[key].oil) === '0' ? ' &nbsp 0' : data[key].oil) + '#') : ''
        reStr += data[key].sale ? ((' 年度累计完成: ' + data[key].sale) + '吨') : ''
        reStr += data[key].process ? ((' 年计划完成进度: ' + ((Number(data[key].process) || 0) * 100).toFixed(0)) + '%') : ''
      }
    }
    if (data.zginfo) {
      reStr += ('<br>虚拟数据，谨慎参考 ')
      reStr += ('<br>整改项目名称: ' + data.zginfo.zgName)
      reStr += ('<br>整改开始时间: ' + data.zginfo.startDate)
      reStr += ('<br>已施工天数: ' + data.zginfo.workDays)
      reStr += ('<br>预计完工时间: ' + data.zginfo.overDay)
    }
    return reStr
  }
}

export const tooltipF2 = function (data) {
  if (['pipe', 'pipe_bak', 'pipe2', 'pipe2_bak'].includes(data.seriesId)) {
    let str = '管道: ' + data.data.name
    if (data.data.data && data.data.data.cd) {
      str += '<br>长度: ' + data.data.data.cd
    }
    return str
  } else if (data.seriesId.includes('gas_zsy_warning')) {
    data = data.data.data
    let reStr = (data.name || '')
    if (data.isWarning) {
      reStr += '<br>' + data.isWarning
      return reStr
    }
  } else if (data.seriesId === 'railway') {
    return '铁路: ' + data.data.name
  } else if (data.seriesId.includes('depot')) {
    data = data.data.data
    let reStr = ''
    reStr += data.name + '<br/>油品: '
    if (data.o0 === 1) {
      reStr += '0# '
    }
    if (data.o92 === 1) {
      reStr += '92# '
    }
    if (data.o95 === 1) {
      reStr += '95# '
    }
    if (data.o98 === 1) {
      reStr += '98# '
    }
    return reStr
  } else {
    data = data.data.data
    let reStr = ''
    if (data && data.length && data.length > 0) {
      reStr = '加油站数量:  ' + data.length + '<br>'
      if (data.length < 5) {
        data.forEach((item, index) => {
          reStr += item.name + '<br>'
        })
      }
      return reStr
    }
    reStr += (data.name || '')
    if (data.isWarning) {
      reStr += '<br>' + data.isWarning
      return reStr
    }
    for (let key in data) {
      if (['0', '92', '95', '98', '柴油', '汽油'].includes(key)) {
        reStr += data[key].oil ? ('<br>' + ((data[key].oil) === '0' ? ' &nbsp 0' : data[key].oil) + '#') : ''
        reStr += data[key].sale ? ((' 8月日均销量: ' + data[key].day8sale) + '吨') : ''
        reStr += data[key].process ? ((' 8月日均销量同比: ' + ((Number(data[key].huanbi8) || 0) * 100).toFixed(0)) + '%') : ''
      }
    }
    if (data.zginfo) {
      reStr += ('<br>虚拟数据，谨慎参考 ')
      reStr += ('<br>整改项目名称: ' + data.zginfo.zgName)
      reStr += ('<br>整改开始时间: ' + data.zginfo.startDate)
      reStr += ('<br>已施工天数: ' + data.zginfo.workDays)
      reStr += ('<br>预计完工时间: ' + data.zginfo.overDay)
    }
    return reStr
  }
}

let getSizeFunProcess = (data) => {
  let num = 2
  let processD = Number(data.process) || 0
  let size = ((processD / num) > 1 ? 1 : (processD / num)) * maxSize
  return size > minSize ? size : minSize
}

export const convertData = (data) => {
  let newData = []
  data.forEach((item, index) => {
    let dataItem = {
      name: item.name,
      adr: item.address,
      group: item.type,
      gasType: item.tag,
      point: [item.lng, item.lat],
      cmp: item.company,
      oil: item.oil,
      sale17: item.sale2017 || 0,
      sale: item.sale2018 || 0,
      plan: item.plan || 0,
      process: item.process || 0,
      area: item.area,
      areaQx: item.district
    }
    dataItem['sale'] = dataItem['sale'] || item.sale2017
    dataItem['day8sale'] = dataItem.sale ? (Number(dataItem.sale) / 8 / 30).toFixed(2) : 0
    dataItem['day8sale17'] = dataItem.sale17 ? (Number(dataItem.sale17) / 365).toFixed(2) : 0
    dataItem['huanbi8'] = dataItem.day8sale17 ? (Number(dataItem.day8sale) / Number(dataItem.day8sale17)).toFixed(2) : 0
    dataItem['sizesale'] = getSizeFunSeal(dataItem.sale, sealSizeNum[dataItem.oil])
    dataItem['sizeprocess'] = getSizeFunProcess(dataItem)
    newData.push(dataItem)
  })
  let newDataMap = {}
  newData.forEach((item, index) => {
    let key = item.name
    if (typeof newDataMap[key] === 'undefined') {
      newDataMap[key] = {
        name: item['name'],
        adr: item.adr,
        group: item.group,
        sale17: item.sale17,
        gasType: item['gasType'],
        point: item.point,
        cmp: item.cmp,
        area: item.area,
        areaQx: item.areaQx,
        sizesale: 0,
        sizeprocess: 0,
        oilNum: 0,
        totalSale: 0
      }
      // if (newDataMap[key].name === '云南销售昆明分公司干坝塘加油站') {
      //   newDataMap[key].isWarning = '预警类型: 设备工况报警<br>具体情况: 液位仪故障'
      // }
      // if (newDataMap[key].name === '云南销售红河分公司异龙湖加油站2站') {
      //   newDataMap[key].isWarning = '预警类型: 安全运行预警<br>具体情况: 1号罐 0号车用柴油即将过期<br>已销售: 79天<br>保质期: 90天'
      // }
      // if (newDataMap[key].name === '云南销售曲靖分公司曲靖福宝加油站') {
      //   newDataMap[key].isWarning = '预警类型: 安全运行预警<br>具体情况: 3号罐 98号车用汽油即将过期<br>已销售: 83天<br>保质期: 90天'
      // }
      // if (newDataMap[key].name === '普洱分公司中原加油站二站') {
      //   newDataMap[key].isWarning = '预警类型: 库存预警<br>具体情况: 0号柴油存在断油风险<br>当前库存量：30142升<br>今日预测销量：49500升 运距339公里<br>在途情况：无在途'
      // }
      // if (newDataMap[key].name === '云南销售大理分公司顺达加油站') {
      //   newDataMap[key].isWarning = '预警类型: 库存预警<br>具体情况: 0号柴油存在断油风险<br>当前库存量：8783升<br>今日预测销量：77415升 运距6公里<br>在途情况：无在途'
      // }
      // if (newDataMap[key].name === '云南销售昆明分公司明波加油站1站') {
      //   newDataMap[key].isWarning = '预警类型: 库存预警'
      // }
    }
    if (item.oil && item.sale) {
      newDataMap[key][item.oil] = {
        oil: item.oil,
        plan: item.plan,
        sale: item.sale,
        daySale: (Number(item.sale) / 12).toFixed(2),
        process: item.process,
        sizesale: item.sizesale,
        sizeprocess: item.sizeprocess,
        day8sale: item['day8sale'],
        huanbi8: item['huanbi8']
      }
      newDataMap[key].oilNum += 1
      newDataMap[key].sizeprocess += newDataMap[key][item.oil].sizeprocess
      newDataMap[key].totalSale += Number(newDataMap[key][item.oil].sale) || 0
    }
  })
  let newData2 = []
  for (let key in newDataMap) {
    newDataMap[key].sizeprocess = newDataMap[key].oilNum > 0 ? (newDataMap[key].sizeprocess / newDataMap[key].oilNum) : minSize
    newDataMap[key].sizesale = getSizeFunSeal(newDataMap[key].totalSale, sealSizeNum['total'])
    newDataMap[key].saleType = getSaleType(newDataMap[key].totalSale)
    newData2.push(newDataMap[key])
    if (!newDataMap[key]['汽油'] && !newDataMap[key]['柴油'] && !newDataMap[key]['0'] && !newDataMap[key]['92'] && !newDataMap[key]['95'] && !newDataMap[key]['98']) {
      newDataMap[key].zginfo = {
        zgName: '双层罐整改',
        startDate: '2018-08-17',
        workDays: 27,
        overDay: '18天'
      }
    }
  }
  return newData2
}

export const mapCompanys = [{
  name: '昆明分公司',
  center: [102.769916, 25.099276]
},
{
  name: '楚雄分公司',
  center: [101.555697, 25.487749]
},
{
  name: '普洱分公司',
  center: [101.048836, 23.020855]
},
{
  name: '曲靖分公司',
  center: [103.800338, 25.524763]
},
{
  name: '玉溪分公司',
  center: [102.513617, 24.279692]
},
{
  name: '红河分公司',
  center: [103.148315, 23.370747]
},
{
  name: '文山分公司',
  center: [104.416148, 23.673176]
},
{
  name: '丽江分公司',
  center: [100.244998, 26.876074]
},
{
  name: '昭通分公司',
  center: [104.010965, 27.547412]
},
{
  name: '保山分公司',
  center: [98.84738, 25.24506]
},
{
  name: '临沧分公司',
  center: [99.633484, 23.797597]
},
{
  name: '德宏分公司',
  center: [98.147056, 24.592791]
},
{
  name: '版纳分公司',
  center: [100.92694, 21.85469]
},
{
  name: '大理分公司',
  center: [100.169521, 25.674736]
}]

export const oilTypes = [{
  label: '全部油品',
  key: 'all'
},
{
  label: '0号 车用柴油(Ⅵ)',
  key: '0'
},
{
  label: '92号 车用汽油(ⅥA)',
  key: '92'
},
{
  label: '95号 车用汽油(ⅥA)',
  key: '95'
},
{
  label: '98号 车用汽油(ⅥA)',
  key: '98'
}]

export const gasTypes = [{
  label: '高速站',
  key: '高速站'
},
{
  label: '国道站',
  key: '国道站'
},
{
  label: '省道站',
  key: '省道站'
},
{
  label: '县级站',
  key: '县级站'
},
{
  label: '城区站',
  key: '城区站'
},
{
  label: '农村站',
  key: '农村站'
}]

export const saleTypes = [{
  key: 'dy10',
  label: '一类(10000吨以上)'
},
{
  key: 'qj5z10',
  label: '二类(5000～10000吨)'
},
{
  key: 'qj3z5',
  label: '三类(3000～5000吨)'
},
{
  key: 'xy3',
  label: '低销(3000吨以下)'
}]

export const volumeType = [{
  label: '本年度累计完成量',
  key: 'sale'
},
{
  label: '年计划完成进度',
  key: 'process'
}]

export const depotTypes = [{
  label: '管道库',
  key: '管道库'
},
{
  label: '铁路库',
  key: '铁路库'
},
{
  label: '地付',
  key: '地付'
}]

export const depotCompanys = [{
  label: sysEnv.zsyName,
  key: sysEnv.zsyName
},
{
  label: '中石化',
  key: '中石化'
},
{
  label: '国储',
  key: '国储'
},
{
  label: '中航油',
  key: '中航油'
},
{
  label: '社会',
  key: '社会'
}]



// WEBPACK FOOTER //
// ./src/store/modules/map/map_lib.js